import AsyncStorage from '@react-native-async-storage/async-storage'
import { useEffect, useState } from 'react'

export function useIsFirstRun() {
  // Assume the app is first run until we check the AsyncStorage
  const [isFirstRun, setIsFirstRun] = useState(true)

  useEffect(() => {
    void AsyncStorage.getItem('install_timestamp').then((installTimestamp) => {
      if (!installTimestamp) {
        void AsyncStorage.setItem('install_timestamp', new Date().toISOString())
        setIsFirstRun(true)
      } else {
        setIsFirstRun(false)
      }
    })
  }, [])

  return isFirstRun
}
